import { StudyOverviewContentModel } from '../generated/types/StudyOverviewContentModel';
import { StudyOverviewContentMock } from '../generated/mocks/StudyOverviewContentModelMock';

const defaultStudyOverviewContentMock = StudyOverviewContentMock
  .study_overview[0] as unknown as StudyOverviewContentModel;

const create = (partial?: Partial<StudyOverviewContentModel>): StudyOverviewContentModel => ({
  ...defaultStudyOverviewContentMock,
  ...partial,
});

export const StudyOverviewContentModelMock = { create };
